/**
 * Created by soundview on 3/6/15.
 */
/**
 * Created by soundview on 3/5/15.
 */
var View = require('views/base/view');
var Model = require('models/insulation-quote');
var Collection = require('models/insulation-quote-collection');


module.exports = View.extend({
	autoRender: true,
	tagName: 'tr',
	container: '#quoteList',
	template: require('./templates/insulation-view'),
	events: {
		'click': 'onClick'
	},
	initialize: function (options) {
		console.log(this.model);
		_.bindAll(this, 'render');
	},
	render: function () {
		this.$el.html(this.template(this.getTemplateData()));
	},
	onClick: function (a) {
		this.model.collection.trigger('toView', this.model, this);
	}


});

